<template>
    <v-app> 
         <Tabs :routes='route' colors="#a21706" />
            <v-container>
                <transition name="slide-fade">
                 <router-view></router-view>
                </transition>
            </v-container>
            <Menu type="usuario"/>     
        </v-app>
</template>
<script>

import Tabs from '../../component/layouts/content/tabs'
import Menu from '../../component/layouts/single'

export default {
    components:{
        Tabs,
        Menu
    },

    mounted() {
        this.GetUser();
    },

    methods: {
        GetUser:function(){
            
            
            if (this.user.type == 'supervisor') {
                this.$store.dispatch('GetUserAppsActions', this.user.id);        
            }else{
                this.$store.dispatch('GetUserAppActions');
                this.$store.dispatch('GetUserSupervisorActions');
            }
            
        }
    },

    computed: {
        user(){
            return this.$store.state.currentUser.user;
        },
    },

    data(){
        return {

            route:[
                {
                    id:1,
                    type:'administrador',
                    name:'Lista de Usuarios Coordinador',
                    icon:'mdi-desktop-mac',
                    route:'/usuarios',
                    items: [
                        {
                        text: 'Inicio',
                        disabled: false,
                        href: '/',
                        },
                        {
                        text: 'Vehículo',
                        disabled: true,
                        href: 'Vehiculo',
                        },
                        
                    ],
                
                },
                
                
                {
                    id:2,
                    name:'Lista de Usuarios Aplicacion',
                    icon:'mdi-cellphone-iphone',
                    route:'/usuariosapp',
                    items: [
                        {
                        text: 'Inicio',
                        disabled: false,
                        href: '/',
                        },
                        {
                        text: 'Vehículo',
                        disabled: true,
                        href: 'Vehiculo',
                        },
                        
                    ],
                
                },
                
                

                {
                    id:3,
                    name:'Crear Usuarios',
                    icon:'mdi-account-plus',
                    route:'/usuarios/crear',
                    items: [
                        {
                        text: 'Inicio',
                        disabled: false,
                        href: '/',
                        },
                        {
                        text: 'Vehiculo',
                        disabled: false,
                        href: '/Vehiculo',
                        },
                        {
                        text: 'Crear',
                        disabled: true,
                        href: '/Vehiculo/crear',
                        },
                        
                    ],

                },
            ]

        }
    }

  }
</script>